import http from '@/plugins/axios';

export default {
  getQuestions: ({ rowsPerPage, sortBy, descending, page, filterBy }) => {
    const params = {
      start: rowsPerPage * (page - 1) || 0,
      length: rowsPerPage,
      order: sortBy[0],
      order_direction: descending ? 'desc' : 'asc',
      filterBy: filterBy ? filterBy : null,
    };
    return http
      .get('/questions', {
        params,
      })
      .then(res => {
        return res.data;
      });
  },
  updateQuestion: ({ id, questionText, answerText, posted }) => {
    const params = {
      questionText,
      answerText,
      posted,
    };
    return http.post(`/questions/${id}/edit`, params).then(response => response.data);
  },
  deleteQuestion: id => {
    return http.post(`/questions/${id}/delete`).then(response => response.data);
  },
  createQuestion: (id, { questionText, answerText, posted }) => {
    const params = {
      questionText,
      answerText,
      posted,
    };
    return http
      .post(`/products/${id}/question-answer/create`, params)
      .then(response => response.data);
  },
  createAnswer: ({ id, answerText, posted }) => {
    const params = {
      answerText,
      posted,
    };
    return http.post(`/questions/${id}/answer/create`, params).then(response => response.data);
  },
  getProductQuestions: (id, { rowsPerPage, sortBy, descending, page, filterBy }) => {
    const params = {
      start: rowsPerPage * (page - 1) || 0,
      length: rowsPerPage,
      order: sortBy[0],
      order_direction: descending ? 'desc' : 'asc',
      filterBy: filterBy ? filterBy : null,
    };
    return http
      .get(`/products/${id}/questions`, {
        params,
      })
      .then(res => {
        return res.data;
      });
  },
};
